// Converte um `number` para texto no formato brasileiro (vírgula como
// separador decimal, sempre 2 casas), o caminho inverso de
// `parseLocaleNumber.ts`. `Number.prototype.toFixed(2)` sozinho produz
// separador `.` (convenção en-US, ex. "12.50"), o que quebra a regra
// invólavel do projeto de que toda exibição de número/moeda segue a
// convenção pt-BR (ex. "12,50") — ver CLAUDE.md #1.
//
// Sem separador de milhar: a spec de referência (domain/pricing.ts, Etapa 7)
// também não usa, então não há necessidade de replicar aqui.
export function formatLocaleNumber(value: number): string {
  return value.toFixed(2).replace('.', ',');
}
